import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['company', 'trainingSubmit']

  initialize() {
    this.companyId = this.companyTarget.dataset.companyId;
    this.trainingCategoryId = this.companyTarget.dataset.trainingCategoryId;
    this.charts = $('.insight-chart').map(function() { return this.id.split('#')[1]; }).get();
    this.daterangeCharts = $('.daterange-chart').map(function() { return this.id.split('#')[1]; }).get();
    this.startDate = moment().subtract(12, 'month');
    this.endDate = moment();
    this.applicationLaunchDate = '2019-01-01';
  }

  connect() {
    this.initializeDateRangePicker();
    let queryParams = this.buildQueryParams();
    queryParams = queryParams.length ? queryParams : '';
    this.loadCharts(this.charts, 0, `&${queryParams}&start_date=${this.startDate}&end_date=${this.endDate}`);
  }

  toggleTooltip() {
    $('.lj-tooltip').hover(function() {
      $(this).find('.tooltipinfo').removeClass('d-none');
    }, function() {
      $(this).find('.tooltipinfo').addClass('d-none');
    });
  }

  loadFilteredCharts(startDate, endDate, group_by) {
    let queryParams = this.buildQueryParams();
    queryParams = queryParams.length ? queryParams : '';
    var params = `&start_date=${startDate}&end_date=${endDate}&group_by=${group_by}&${queryParams}`;
    this.loadCharts(this.daterangeCharts, 0, params);
  }

  loadCharts(charts, chart_id, params) {
    let url = this.trainingCategoryId == undefined
              ? `/companies/${this.companyId}/insights?chart_id=${charts[chart_id]}${params}`
              : `/companies/${this.companyId}/insights?chart_id=${charts[chart_id]}&training_category_id=${this.trainingCategoryId}${params}`;

    if (chart_id < charts.length) {
      Rails.ajax({
        url: url,
        type: 'GET',
        dataType: 'script',
        success: (data) => {
          chart_id += 1;
          this.loadCharts(charts, chart_id, params);
        },
        error: (xhr, status, error) => {
          console.error(`Error loading chart ${error}`);
          chart_id += 1;
          this.loadCharts(charts, chart_id, params);
        }
      });
    }
  }

  initializeDateRangePicker() {
    const self = this;
    $('.daterange__field').daterangepicker({
      startDate: moment().subtract(12, 'month'),
      endDate: moment(),
      maxDate: moment(),
      minDate: moment(this.applicationLaunchDate),
      locale: {
        format: 'MMM D, YYYY',
        separator: ' - '
      },
      showDropdowns: true,
      autoApply: true,
    }, function(start, end) {
        $('#dropdown-text').text('Custom');
        self.loadFilteredCharts(start, end, 'month');
    });
  }

  selectDate(event) {
    const selectedValue = $(event.target).text();
    const picker = $('.daterange__field').data('daterangepicker');
    const dateRanges = {
      'Today': moment(),
      'Last 7 days': moment().subtract(6, 'days'),
      'Last month': moment().subtract(1, 'month'),
      'Last 3 months': moment().subtract(3, 'month'),
      'Last 12 months': moment().subtract(12, 'month'),
      'Month to date': moment().startOf('month'),
      'Quarter to date': moment().month(Math.floor(moment().month() / 3) * 3).startOf('month'),
      'Year to date': moment().startOf('year'),
      'All time': moment(this.applicationLaunchDate),
    };
    const startDate = dateRanges[selectedValue];
    const endDate = moment();
    const group_by = selectedValue == 'Today' ? 'hour' : selectedValue == 'Last 7 days' ? 'days' : selectedValue == 'Last month' ? 'week' : 'month'

    if (startDate) {
      $('#dropdown-text').text(selectedValue);
      picker.setEndDate(endDate);
      picker.setStartDate(startDate);
      this.loadFilteredCharts(startDate, endDate, group_by);
    }
  }

  buildQueryParams() {
    var filters = {
      company: 'q[company_id_in][]',
      region: 'q[region_id_in][]',
      location: 'q[location_id_in][]',
      roles: 'q[role_in][]',
      department: 'q[department_id_in][]'
    };

    var queryParams = {};

    $.each(filters, function(arrayName, paramName) {
      if (arrayName == 'location' || arrayName == 'department') {
        var selectedValues = new URLSearchParams(window.location.search).getAll(paramName)

        if(selectedValues.length) {
          queryParams[paramName] = selectedValues
        }
      } else {
        var values = $('.' + arrayName + '_checkbox:checked').map(function() { return $(this).val(); }).get();
        if (values.length > 0) {
          queryParams[paramName] = [...new Set(values)];
        }
      }
    });

    var queryString = $.param(queryParams);

    return queryString;
  }

  submitTrainingOverviewForm(event) {
    this.trainingSubmitTarget.click();
  }

  addSkeletonSpinner(event) {
    if ($('#course-status-chart-no-data').is('*')) {
      const spinnerIcon = document.createElement("i");
      spinnerIcon.classList.add("fa", "fa-spinner", "fa-spin", "search-spinner");
      $('.no-chart-data').parent()[0].innerHTML = spinnerIcon.outerHTML;
    } else {
      $('#course-status-tbody').css('display', 'none');
      $('#course-status-skeleton').css('display', 'table-row-group');
    }
  }

  courseTrendsRedirect(event) {
    var trainingCategoryId = $(event.target).closest('.lj-training-card').data('trainingCategoryId')

    window.location.href=`insights/training_categories/${trainingCategoryId}`
  }

   print(event) {
    event.preventDefault();
    window.print();
  }
}
